import './src/styles/global.scss';
import posthog from 'posthog-js';
import React from 'react';
import RootLayout from './src/layouts/rootLayout';

export const onClientEntry = () => {
    posthog.init('phc_uTMjoFMvhvbjhO7bw2a6aARfehIxhvXh7y9DcZy8UPv', {
        api_host: 'https://eu.posthog.com',
        persistence: 'localStorage'
    });
    window.posthog = window.posthog || posthog;
    console.log('onClientEntry: PostHog initialized.');
};

export const onInitialClientRender = () => {

};

export const onRouteUpdate = ({ location }) => {
    // Ensure PostHog is loaded before capturing pageview
    if (window.posthog) {
        window.posthog.capture('$pageview');
    }
    else {
        console.warn('onRouteUpdate: PostHog not available yet.');
    }
};

export const wrapRootElement = ({ element }) => <RootLayout>{element}</RootLayout>;
